import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import styled from "styled-components";
export const ErrorMessage = styled.div `
    margin-top: 8px;
    margin-left: 14px; // matches MUI helper text
    font-size: ${fontSizes.TINY};
    color: ${colors.tulip_main};
`;
